import { PageNotFound } from './ui/pageNotFound'

export default PageNotFound
